exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card{margin:5px}.card,.card a,.card a:hover{display:block;width:140px;height:140px;float:left}.card a,.card a:hover{text-align:center;font-size:20px;text-decoration:none;border:1px solid #bbb;color:#000;cursor:pointer}.card a.cover{background:url(" + require("../assets/img/bg_card_cover.png") + ") no-repeat}.correct{background-color:#70c16d}.correct a,.correct a:hover{text-decoration:none;color:#fff}.summary{display:block;height:20px}.time,.unit{display:block;float:left;width:90px;margin:5px 0 0 50px}.unit{margin-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/app.scss
// module id = 427
// module chunks = 0